import { j as l } from "./jsx-runtime-3tyXYecC.mjs";
import { c as C } from "./index-DkZ16bcJ.mjs";
import { l as z } from "./lodash-5ofSKtz3.mjs";
import { A as V, a as X, I as Z } from "./avatar-1JHdkfls.mjs";
import { m as H } from "./tss-DN0acMKN.mjs";
import { M as R, d as j } from "./constants-CnFYFetN.mjs";
import { f as v } from "./index-LyFokDcn.mjs";
import { L as _ } from "./layout-box-DFBM-kSI.mjs";
import * as p from "react";
import { g as $, c as M } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { i as D } from "./isHostComponent-kiaBvYVo.mjs";
import { m as tt } from "./memoTheme-BzXKG_-k.mjs";
import { L as A, l as et, a as ot } from "./ListItemText-C34sqqNp.mjs";
import { g as B } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as G, u as U, c as E } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { i as st } from "./isMuiElement-DnSE4qG4.mjs";
import { u as rt } from "./useForkRef-C_4o__cU.mjs";
import { L as it } from "./ListItemAvatar-DT4cgzXB.mjs";
function nt(o) {
  return $("MuiListItem", o);
}
B("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
function at(o) {
  return $("MuiListItemSecondaryAction", o);
}
B("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const lt = (o) => {
  const {
    disableGutters: t,
    classes: e
  } = o;
  return E({
    root: ["root", t && "disableGutters"]
  }, at, e);
}, dt = G("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (o, t) => {
    const {
      ownerState: e
    } = o;
    return [t.root, e.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: o
    }) => o.disableGutters,
    style: {
      right: 0
    }
  }]
}), O = /* @__PURE__ */ p.forwardRef(function(t, e) {
  const s = U({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: r,
    ...i
  } = s, d = p.useContext(A), n = {
    ...s,
    disableGutters: d.disableGutters
  }, a = lt(n);
  return /* @__PURE__ */ l.jsx(dt, {
    className: M(a.root, r),
    ownerState: n,
    ref: e,
    ...i
  });
});
O.muiName = "ListItemSecondaryAction";
const ct = (o, t) => {
  const {
    ownerState: e
  } = o;
  return [t.root, e.dense && t.dense, e.alignItems === "flex-start" && t.alignItemsFlexStart, e.divider && t.divider, !e.disableGutters && t.gutters, !e.disablePadding && t.padding, e.hasSecondaryAction && t.secondaryAction];
}, mt = (o) => {
  const {
    alignItems: t,
    classes: e,
    dense: s,
    disableGutters: r,
    disablePadding: i,
    divider: d,
    hasSecondaryAction: n
  } = o;
  return E({
    root: ["root", s && "dense", !r && "gutters", !i && "padding", d && "divider", t === "flex-start" && "alignItemsFlexStart", n && "secondaryAction"],
    container: ["container"]
  }, nt, e);
}, pt = G("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: ct
})(tt(({
  theme: o
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${et.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(o.vars || o).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: o.transitions.create("background-color", {
        duration: o.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (o.vars || o).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), ut = G("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (o, t) => t.container
})({
  position: "relative"
}), gt = /* @__PURE__ */ p.forwardRef(function(t, e) {
  const s = U({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: r = "center",
    children: i,
    className: d,
    component: n,
    components: a = {},
    componentsProps: u = {},
    ContainerComponent: c = "li",
    ContainerProps: {
      className: L,
      ...g
    } = {},
    dense: m = !1,
    disableGutters: f = !1,
    disablePadding: J = !1,
    divider: W = !1,
    secondaryAction: T,
    slotProps: Y = {},
    slots: q = {},
    ...K
  } = s, N = p.useContext(A), P = p.useMemo(() => ({
    dense: m || N.dense || !1,
    alignItems: r,
    disableGutters: f
  }), [r, N.dense, m, f]), Q = p.useRef(null), y = p.Children.toArray(i), w = y.length && st(y[y.length - 1], ["ListItemSecondaryAction"]), I = {
    ...s,
    alignItems: r,
    dense: P.dense,
    disableGutters: f,
    disablePadding: J,
    divider: W,
    hasSecondaryAction: w
  }, F = mt(I), k = rt(Q, e), b = q.root || a.Root || pt, h = Y.root || u.root || {}, S = {
    className: M(F.root, h.className, d),
    ...K
  };
  let x = n || "li";
  return w ? (x = !S.component && !n ? "div" : x, c === "li" && (x === "li" ? x = "div" : S.component === "li" && (S.component = "div")), /* @__PURE__ */ l.jsx(A.Provider, {
    value: P,
    children: /* @__PURE__ */ l.jsxs(ut, {
      as: c,
      className: M(F.container, L),
      ref: k,
      ownerState: I,
      ...g,
      children: [/* @__PURE__ */ l.jsx(b, {
        ...h,
        ...!D(b) && {
          as: x,
          ownerState: {
            ...I,
            ...h.ownerState
          }
        },
        ...S,
        children: y
      }), y.pop()]
    })
  })) : /* @__PURE__ */ l.jsx(A.Provider, {
    value: P,
    children: /* @__PURE__ */ l.jsxs(b, {
      ...h,
      as: x,
      ref: k,
      ...!D(b) && {
        ownerState: {
          ...I,
          ...h.ownerState
        }
      },
      ...S,
      children: [y, T && /* @__PURE__ */ l.jsx(O, {
        children: T
      })]
    })
  });
}), ft = H()((o, t) => {
  var n, a, u, c;
  const { palette: e, spacing: s, typography: r, mode: i } = o, { disabled: d } = t;
  return {
    root: {
      outline: i === R.Dye ? `2px solid ${j.main}` : void 0,
      padding: 0
    },
    text: {
      display: "flex",
      flexDirection: "column",
      gap: s(0.25),
      margin: 0
    },
    textPrimary: {
      fontSize: (n = r.medium) == null ? void 0 : n.fontSize,
      lineHeight: (a = r.medium) == null ? void 0 : a.lineHeight,
      color: d ? e.gray[600] : e.gray[1e3]
    },
    textSecondary: {
      fontSize: (u = r.xsmall) == null ? void 0 : u.fontSize,
      lineHeight: (c = r.xsmall) == null ? void 0 : c.lineHeight,
      color: e.gray[600]
    }
  };
}), yt = H()((o, t) => {
  const { palette: e, spacing: s, mode: r } = o, { highlighted: i, isStringAvatar: d } = t;
  let n = "transparent", a = e.primary.main;
  return d && (n = i ? e.primary.contrastText : e.primary.main), r === R.Dye ? a = j.main : i && (a = e.primary.contrastText), {
    root: {
      backgroundColor: i ? e.primary.main : "transparent",
      outline: r === R.Dye ? `2px solid ${j.main}` : void 0,
      padding: s(1, 1, 1, 2),
      "& .MuiListItemAvatar-root": {
        minWidth: 0
      },
      "& .MuiListItemText-root": {
        margin: 0
      }
    },
    avatar: {
      backgroundColor: n,
      color: i ? e.primary.main : e.primary.contrastText,
      fill: a,
      height: 32,
      marginRight: 10,
      width: 32
    },
    textPrimary: {
      color: i ? e.primary.contrastText : e.grey[1e3],
      fontSize: 15,
      lineHeight: "22px"
    },
    textSecondary: {
      color: i ? e.primary.contrastText : e.grey[700],
      fontSize: 13,
      lineHeight: "22px"
    }
  };
});
function Ft({
  avatar: o,
  avatarAlt: t,
  avatarSrc: e,
  classes: s = {},
  className: r,
  component: i = "li",
  description: d,
  disabled: n,
  /* @startCleanup encore */
  highlighted: a = !1,
  /* @endCleanup encore */
  title: u,
  /* @startCleanup encore */
  variant: c = "circular",
  /* @endCleanup encore */
  ...L
}) {
  const { classes: g } = ft({
    disabled: n,
    /* @startCleanup encore */
    highlighted: a,
    isStringAvatar: !!o && z.isString(o)
    /* @endCleanup encore */
  }), { classes: m } = yt({
    disabled: n,
    /* @startCleanup encore */
    highlighted: a,
    isStringAvatar: !!o && z.isString(o)
    /* @endCleanup encore */
  });
  return /* @__PURE__ */ l.jsxs(
    gt,
    {
      className: v.ifFeature("encore", g.root, C(m.root, r, s.root)),
      component: i,
      disableGutters: !0,
      ...L,
      "data-fabric-component": "AvatarListOption",
      children: [
        v.ifFeature(
          "encore",
          /* @__PURE__ */ l.jsx(_, { flexShrink: 0, marginRight: 1, children: /* @__PURE__ */ l.jsx(V, { alt: t, size: 32, src: e, children: f() }) }),
          /* @__PURE__ */ l.jsx(it, { children: /* @__PURE__ */ l.jsx(
            X,
            {
              alt: t,
              classes: { root: C(m.avatar, s.avatar) },
              src: e,
              variant: c,
              children: f()
            }
          ) })
        ),
        /* @__PURE__ */ l.jsx(
          ot,
          {
            className: g.text,
            primary: u,
            primaryTypographyProps: {
              className: v.ifFeature("encore", g.textPrimary, C(m.textPrimary, s.primaryText))
            },
            secondary: d,
            secondaryTypographyProps: {
              className: v.ifFeature("encore", g.textSecondary, C(m.textSecondary, s.secondaryText))
            }
          }
        )
      ]
    }
  );
  function f() {
    return e ? null : o || v.ifFeature("encore", void 0, /* @__PURE__ */ l.jsx(Z, {}));
  }
}
export {
  Ft as A
};
//# sourceMappingURL=avatar-list-option-CBlVAHq9.mjs.map
